'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.updateURL = updateURL;
exports.loadFromURL = loadFromURL;

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateURL(selectedStory) {
  if (selectedStory) {
    var baseQuery = _qs2.default.parse(window.location.search.replace('?', ''));
    var nextQuery = _qs2.default.stringify(_extends({}, baseQuery, { selectedStory: selectedStory }));
    window.history.pushState({}, null, '?' + nextQuery);
  }
}

function loadFromURL() {
  var query = _qs2.default.parse(window.location.search.replace('?', ''));
  return query && query.selectedStory || null;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/dev-novel/dist/url-helper.js
// module id = 528
// module chunks = 0